import {
  ACTIVE_STATUS,
  IInfinitePageParams,
  IInfinitePageResponse,
} from 'services/types';

export interface IMessageRecipient {
  id: string;
  name: string;
}

export interface ISaleChannelMutation {
  name: string;
  messageRecipientId: string | null;
  messageRecipientName: string | null;
  isActive: boolean;
  distributionFormId: DISTRIBUTION_FORM;
  defaultProviderId: string;
  canBeSent: boolean;
  isGlobalSendAllowed: boolean;
  requireVideoRectangleCover: boolean;
  acceptVideo: boolean;
  acceptVideoWithTrack: boolean;
}

export interface ISaleChannelForm
  extends Omit<ISaleChannelMutation, 'isActive'> {
  isActive: ACTIVE_STATUS;
  file: File | null;
  logoImageUrl: string | null;
  ddexStandard: DDEX_STANDARD;
  defaultProviderName: string;
  isPredefined: boolean;
}

export interface ICreateSaleChannel extends ISaleChannelMutation {}

export interface IUpdateSaleChannel extends ISaleChannelMutation {
  id: string;
}

export interface ISalesChannelResponse {
  id: string;
  name: string;
  isActive: boolean;
  distributionForm: DISTRIBUTION_FORM;
  messageRecipient: null | IMessageRecipient;
  ddexStandard: DDEX_STANDARD;
  logoImageUrl: null | string;
  defaultProviderId: string;
  defaultProviderName: string;
  isPredefined: boolean;
  canBeSend: boolean;
  isGlobalSendAllowed: boolean;
  requireVideoRectangleCover: boolean;
  acceptVideo: boolean;
  acceptVideoWithTrack: boolean;
}

export interface ISalesChannelSearchParams extends IInfinitePageParams {}

export interface ISalesChannelLightListParams {
  distributionFormId?: DISTRIBUTION_FORM;
  enabled?: boolean;
}

export interface ISalesChannelInfiniteResponse
  extends IInfinitePageResponse<ISalesChannelResponse> {}

export enum DISTRIBUTION_FORM {
  unknown = -1,
  Physical = 1,
  Digital = 2,
  Merch = 3,
  Youtube = 4,
}

export enum DDEX_STANDARD {
  unknown = -1,
  Ddex382 = 0,
  Ddex43 = 1,
}

export interface ISalesChannel {
  salesChannelId: string;
  name: string;
  deliveryMethod: {
    name?: string;
    id?: number;
  };
}

export interface IMusicPlatform {
  id: string;
  name: string;
  salesChannels?: ISalesChannel[];
  map?: () => void;
}

export interface Provider {
  id: string;
  name: string;
}

export interface ProviderOption {
  value: string;
  label: string;
}
